// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "h1{\n    font-size:50px;\n    font-weight:normal;\n    margin:0;\n}\np{\n    font-size:20px;\n    width:80%;\n    text-align:center;\n    margin-top: 0;\n}\n.f_bold{\n    font-weight: 500;\n}\n.login_heading{\n    font-size:25px;\n    text-align: center;\n    margin-bottom:20px;\n}", ""]);
// Exports
module.exports = exports;
